import React from "react";
import ContentViewer from "../Helpers/ContentViewer";

import "../../styles/widgets/MaintenancePage.css";

function MaintenancePage() {
    return (
        <div className="idea-maintenance-page-wrapper">
            <div className="idea-maintenance-page-container">
                <ContentViewer overrideContent="MaintenancePage" />
            </div>
        </div>
    );
}

export default MaintenancePage;
